import { render, staticRenderFns } from "./userRights.vue?vue&type=template&id=221cb2aa&scoped=true"
import script from "./userRights.vue?vue&type=script&lang=js"
export * from "./userRights.vue?vue&type=script&lang=js"
import style0 from "./userRights.vue?vue&type=style&index=0&id=221cb2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221cb2aa",
  null
  
)

export default component.exports